// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"295":"3b96ae3c","455":"2a6cc2db","593":"e733821f"}[chunkId] + ".chunk.js";
};